import { isNull, isUndefined } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class LocationService extends AbstractService {
	static setup(baseURL, options) {
		instance = new LocationService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = APIEndpoints.locations;
		this.locationOverviewEndpoint = 'locationoverview';
		this.geocoderURL = options.geocoderURL;
		this.googleKey = options.googleKey;
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getById(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getById(...params);
	}

	static getLoactionOverview(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getLoactionOverview(...params);
	}

	static exportReport(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._exportReport(...params);
	}

	static save(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._save(...params);
	}

	static getGeoLocation(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getGeoLocation(...params);
	}

	static delete(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._delete(...params);
	}

	static getOfficers(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getOfficers(...params);
	}

	static getPosts(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getPosts(...params);
	}

	static getJobs(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getJobs(...params);
	}

	static getLocationGroupById(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getLocationGroupById(...params);
	}

	static getOfficersByLocationGroup(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getOfficersByLocationGroup(...params);
	}

	static getJobsByLocationGroup(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getJobsByLocationGroup(...params);
	}

	_getAll({
		minimalData,
		includeDeleted,
		pageNumber,
		projectId,
		displayCount = 25,
		clientId,
		organizationId,
		officerId,
		includeStats,
	}) {
		return this.get({
			endpoint    : this.endpoint,
			queryParams : {
				minimalData,
				includeDeleted,
				pageNumber,
				displayCount,
				clientId,
				organizationId,
				projectId,
				officerId,
				includeStats,
			},
		});
	}

	_getById(id, queryParams) {
		return this.get({
			endpoint : `${this.endpoint}/${id}`,
			queryParams,
		});
	}

	_getLoactionOverview(queryParams) {
		return this.get({
			endpoint : this.locationOverviewEndpoint,
			queryParams,
		});
	}

	_exportReport(
		queryParams,
		data,
	) {
		return this.post({
			endpoint : `${this.locationOverviewEndpoint}/exportReport`,
			queryParams,
			data,
		});
	}

	_save({
		id,
		name,
		city,
		projectId,
		locationTypeId,
		zipCode: zipcode,
		address: streetAddress1,
		state: stateId,
		lat: latitude,
		lng: longitude,
		contactId: clientSupervisorContactId,
		organizationFee,
	}) {
		const creating = isUndefined(id);
		const endpoint = `${this.endpoint}${!creating ? `/${id}` : ''}`;

		return this.request({
			endpoint,
			method : creating ? 'POST' : 'PUT',
			data   : {
				name,
				streetAddress1,
				city,
				stateId,
				zipcode,
				latitude,
				longitude,
				projectId,
				locationTypeId,
				clientSupervisorContactId,
				organizationFee,
			},
		});
	}

	_getGeoLocation(address) {
		return this.abstractRequest({
			baseURL         : this.geocoderURL,
			method          : 'GET',
			withCredentials : false,
			headers         : {},
			queryParams     : {
				key : this.googleKey,
				address,
			},
		});
	}

	_delete(id) {
		return this.del({ endpoint : `${this.endpoint}/${id}` });
	}

	_getOfficers(id, queryParams) {
		return this.get({ endpoint : `${this.endpoint}/${id}/officers`, queryParams });
	}

	_getPosts({
		id,
		pagingToken,
		displayCount,
		pageNumber,
	}) {
		return this.get({
			endpoint    : `${this.endpoint}/${id}/posts`,
			queryParams : {
				pagingToken,
				displayCount,
				pageNumber,
			},
		});
	}

	_getJobs(id, queryParams) {
		return this.get({
			endpoint : `${this.endpoint}/${id}/jobevents`,
			queryParams,
		});
	}

	_getLocationGroupById(id, queryParams) {
		return this.get({
			endpoint : `${APIEndpoints.locationGroups}/${id}`,
			queryParams,
		});
	}

	_getOfficersByLocationGroup(id, queryParams) {
		return this.get({
			endpoint : `${APIEndpoints.locationGroups}/${id}/officers`,
			queryParams,
		});
	}

	_getJobsByLocationGroup(id, queryParams) {
		return this.get({
			endpoint : `${APIEndpoints.locationGroups}/${id}/jobevents`,
			queryParams,
		});
	}
}
